var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_578_40051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.0019C18.6274 24.0019 24 18.6294 24 12.0019C24 5.37453 18.6274 0.00195312 12 0.00195312C5.37258 0.00195312 0 5.37453 0 12.0019C0 18.6294 5.37258 24.0019 12 24.0019Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6707 15.4708L17.2023 12.0012H13.8745V9.75008C13.8745 8.80169 14.3386 7.87524 15.8304 7.87524H17.3441V4.92207C17.3441 4.92207 15.9704 4.6875 14.6575 4.6875C11.917 4.6875 10.1248 6.34803 10.1248 9.35689V12.0012H7.07715V15.4708H10.1248V23.8561C10.7357 23.9523 11.3618 24.0013 11.9997 24.0013C12.6376 24.0013 13.2636 23.9506 13.8745 23.8561V15.4708H16.6707Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_578_40051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e120e695baa3efa0650eb2d4bb69be6d.svg";
export { ForwardRef as ReactComponent };